// extracted by mini-css-extract-plugin
export default {"topimage":"Navbvar_topimage__P5Jpf","block":"Navbvar_block__75VLE"};